import { render } from "./WBar.vue?vue&type=template&id=0679632b"
import script from "./WBar.vue?vue&type=script&lang=js"
export * from "./WBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__